export const darkTheme = {
  bg: "#080b14", // Deep rich midnight obsidian
  bgLight: "#0d1222",
  bgSoft: "#131b31",
  bgGlass: "rgba(13, 18, 34, 0.82)",
  primary: "#38bdf8", // Sky cyan (refined, pleasant to eyes)
  primaryGlow: "rgba(56, 189, 248, 0.35)",
  secondary: "#818cf8", // Soft indigo
  secondaryGlow: "rgba(129, 140, 248, 0.3)",
  accent: "#34d399", // Emerald
  accentGlow: "rgba(52, 211, 153, 0.3)",
  text_primary: "#f8fafc",
  text_secondary: "#94a3b8",
  text_muted: "#64748b",
  card: "rgba(13, 18, 34, 0.75)",
  card_light: "#0e1528",
  card_hover: "#141e38",
  border: "rgba(148, 163, 184, 0.14)",
  border_bright: "rgba(56, 189, 248, 0.35)",
  borderGlow: "rgba(56, 189, 248, 0.25)",
  button: "#38bdf8",
  white: "#ffffff",
  black: "#000000",
  soft2: "#64748b",
  shadow: "0 20px 45px -10px rgba(0, 0, 0, 0.7)",
  glowShadow: "0 0 35px -5px rgba(56, 189, 248, 0.2)"
};

export const lightTheme = {
  bg: "#f8fafc",
  bgLight: "#f1f5f9",
  bgSoft: "#e2e8f0",
  bgGlass: "rgba(248, 250, 252, 0.85)",
  primary: "#0284c7",
  primaryGlow: "rgba(2, 132, 199, 0.25)",
  secondary: "#6366f1",
  secondaryGlow: "rgba(99, 102, 241, 0.2)",
  accent: "#059669",
  accentGlow: "rgba(5, 150, 105, 0.2)",
  text_primary: "#0f172a",
  text_secondary: "#475569",
  text_muted: "#64748b",
  card: "rgba(255, 255, 255, 0.9)",
  card_light: "#ffffff",
  card_hover: "#f8fafc",
  border: "rgba(15, 23, 42, 0.1)",
  border_bright: "rgba(2, 132, 199, 0.3)",
  borderGlow: "rgba(2, 132, 199, 0.15)",
  button: "#0284c7",
  white: "#ffffff",
  black: "#000000",
  soft2: "#64748b",
  shadow: "0 20px 40px -15px rgba(15, 23, 42, 0.08)",
  glowShadow: "0 0 30px -5px rgba(2, 132, 199, 0.15)"
};
